import getApiClient from '@/plugins/api'
import { cpf } from 'cpf-cnpj-validator'

export default {
  loadCart: function() {
    const cart = this.$route.params.id
    const api = getApiClient(this.$store)
    this.travelers = []

    this.$store.commit('startLoading')
    api.get(`/carts?token=${cart}`)
      .then(result => {
        this.cart = result.data['hydra:member'][0]
        if (result.data.boardingPlace) {
          this.cart.boardingPlace = parseInt(result.data.boardingPlace.replace(/[^0-9]/g, ''))
        }

        api.get(this.cart.trip)
          .then(result => {
            this.trip = result.data
            if (this.cart.boardingPlace) {
              this.cart.boardingPlace = parseInt(this.cart.boardingPlace.replace(/[^0-9]/g, ''))
            }
            this.updateTravelers()
          })
      })
      .catch(error => {
        location.href = 'https://voudetrip.com.br'
      })
      .finally(() => {
        this.$store.commit('stopLoading')
      })
  },

  updateTravelers() {
    let totalTravelers = 0
    this.travelers = []
    this.cart.accommodations.forEach(accommodation => {
      totalTravelers += accommodation.quantity
      this.trip.accommodations.forEach(tripAccommodation => {
        tripAccommodation.peopleTypeValue.forEach(peopleTypeValue => {
          if (peopleTypeValue.id === accommodation.id) {
            peopleTypeValue.quantity = accommodation.quantity
          }
        })
      })
    })

    if (this.cart.travelers?.length === totalTravelers) {
      this.travelers = this.cart.travelers
    } else {
      for (let i = 1; i <= totalTravelers; i++) {
        this.travelers.push({
          name: i === 1 ? this.cart.user.name : null,
          document: i === 1 ? this.cart.user.cpf : null,
          rg: i === 1 ? this.cart.user.rg : null,
          noCpf: false,
          noRg: false,
          rgError: null,
          cpfError: null
        })
      }
    }
  },

  saveCart(validate = true) {
    const api = getApiClient(this.$store)

    let totalErrors = 0;
    this.travelers.forEach(traveler => {
      if (!traveler.name || this.nameRules(traveler.name).length) {
        totalErrors++
      }

      if ((!traveler.document && !traveler.noCpf) || (!traveler.noCpf && this.cpfRules(traveler.document).length)) {
        totalErrors++
      }

      if ((!traveler.rg && !traveler.noRg) || (!traveler.noRg && this.rgRules(traveler.rg).length)) {
        totalErrors++
      }
    })

    if (totalErrors > 0 && validate) {
      this.success = false
      this.error = 'Preencha todos os dados obrigatórios'
      return
    }

    this.$store.commit('startLoading')
    this.success = false
    this.error = null

    if (!this.cart.boardingPlace) {
      this.error = 'Escolha um local de embarque'
      this.$store.commit('stopLoading')
      return
    }

    api.patch(this.cart['@id'], {
      travelers: this.travelers,
      boardingPlace: `/trip_boardings/${this.cart.boardingPlace}`,
      accommodations: this.cart.accommodations,
      optionals: this.cart.optionals,
      isComplete: this.cart.isComplete ? true : validate,
      updateSeats: !this.cart.isComplete
    }, {
      headers: {
        'Content-Type': 'application/merge-patch+json'
      }
    })
      .then(() => {
        this.success = true
        this.error = null
        this.loadCart()
      })
      .catch(error => {
        this.error = error
        this.success = false
      })
      .finally(() => {
        this.$store.commit('stopLoading')
      })
  },

  getTripCover(trip) {
    if (trip && trip.cover) {
      const baseUrl = process.env.VUE_APP_BASE_URL

      return `${baseUrl}/assets/img/fb_imgs/${trip.cover}`
    }
  },

  getAgencyPicture(agency) {
    if (agency.picture && agency.picture) {
      const baseUrl = process.env.VUE_APP_BASE_URL

      return `${baseUrl}/${agency.picture}`
    }
  },

  cpfRules(value) {
    const result = []
    if (value) {
      const validationResult = this.validateCpf(value)
      const duplicationResult = this.uniqueCpf(value)

      if (typeof validationResult === 'string') {
        result.push(validationResult)
      }

      if (typeof duplicationResult === 'string') {
        result.push(duplicationResult)
      }
    }

    return result
  },

  rgRules(value) {
    const result = []
    if (value) {
      const validationResult = this.validateRg(value)
      const duplicationResult = this.uniqueRg(value)

      if (!validationResult) {
        result.push('RG inválido')
      }

      if (typeof duplicationResult === 'string') {
        result.push(duplicationResult)
      }
    }

    return result
  },

  birthDateRules(value) {
    const result = []
    if (value) {
      const validationResult = this.validateBirthDate(value)

      if (typeof validationResult === 'string') {
        result.push(validationResult)
      }
    }

    return result
  },

  emailRules(value) {
    const result = []
    if (value) {
      const validationResult = this.validateEmail(value)
      const duplicationResult = this.uniqueEmail(value)

      if (!validationResult) {
        result.push('E-mail inválido')
      }

      if (typeof duplicationResult === 'string') {
        result.push(duplicationResult)
      }
    }

    return result
  },

  phoneRules(value) {
    const result = []
    if (value) {
      const duplicationResult = this.uniquePhone(value)

      if (typeof duplicationResult === 'string') {
        result.push(duplicationResult)
      }
    }

    return result
  },

  nameRules(value) {
    const result = []
    if (value) {
      const validationResult = this.validateName(value)

      if (typeof validationResult === 'string') {
        result.push(validationResult)
      }
    }

    return result
  },

  validateCpf(value) {
    if (value.length === 14) {
      return cpf.isValid(value) ? true : 'CPF inválido'
    }

    return 'CPF inválido'
  },

  validateName(value) {
    if (value.trim().split(/\s+/).length < 2) {
      return 'Preencha o nome completo'
    }

    return true
  },

  uniqueCpf(value) {
    let usingSameCpf = 0;
    this.travelers.forEach(traveler => {
      if (traveler.document === value) {
        usingSameCpf++
      }
    })

    return usingSameCpf > 1 ? 'Este CPF já foi adicionado' : null
  },

  uniqueRg(value) {
    let usingSameRg = 0;
    this.travelers.forEach(traveler => {
      if (traveler.rg === value) {
        usingSameRg++
      }
    })

    return usingSameRg > 1 ? 'Este RG já foi adicionado' : true
  },

  validateRg(value) {
    return value.length > 4;
  },

  validateBirthDate(value) {
    if(!value) {
      return true;
    }

    const regExp = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/;

    if(!regExp.test(value)) {
      return 'Data inválida';
    }
  },

  validateEmail(value) {
    const regExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return regExp.test(value);
  },

  uniqueEmail(value) {
    const usingSameEmail = this.travelers.filter(traveler => traveler.email === value).length;

    return usingSameEmail > 1 ? 'Este e-mail já foi adicionado' : true;
  },

  uniquePhone(value) {
    const usingSamePhone = this.travelers.filter(traveler => traveler.phone === value).length;

    return usingSamePhone > 1 ? 'Este telefone já foi adicionado' : true;
  },

  setNoCpf(event, traveler) {
    traveler.noCpf = event.target.checked
  },

  setNoRg(event, traveler) {
    traveler.noRg = event.target.checked
  },

  setBoardingPlace: function(place) {
    this.cart.boardingPlace = place
  },

  getSelectedAccommodation(accommodationId) {
    return this.cart?.accommodations?.filter(accommodation => {
      return accommodation.id === accommodationId
    })?.pop()
  },

  selectAccommodation(accommodationPeopleTypeValue, accommodation) {
    const isSelected = this.getSelectedAccommodation(accommodationPeopleTypeValue.id)

    if (isSelected) {
      this.removeAccommodation(accommodationPeopleTypeValue.id)
      accommodationPeopleTypeValue.quantity = 0
      return
    }

    if (accommodation.vacancies) {
      this.cart.accommodations.push(accommodationPeopleTypeValue)
      accommodationPeopleTypeValue.quantity = 1
    }
  },

  removeAccommodation(accommodationId) {
    this.cart.accommodations = this.cart.accommodations.filter(accommodation => {
      return accommodation.id !== accommodationId
    })
  },

  updateAccommodationSelection(accommodation) {
    const isSelected = this.getSelectedAccommodation(accommodation.id)
    if (! accommodation.quantity) {
      accommodation.quantity = 0
    }
    if (isSelected) {
      isSelected.quantity = accommodation.quantity
    }
    if (accommodation.quantity > 0 && !isSelected) {
      this.cart.accommodations.push(accommodation)
      return
    }

    if (!accommodation.quantity && isSelected) {
      this.removeAccommodation(accommodation.id)
      return
    }
  },

  getSelectedOptional(optionalId) {
    return this.cart?.optionals?.filter(optional => {
      return optional.id === optionalId
    })?.pop()
  },

  removeOptional(optionalId) {
    this.cart.optionals = this.cart.optionals.filter(optional => {
      return optional.id !== optionalId
    })
  },

  selectOptional(optional) {
    const isSelected = this.getSelectedOptional(optional.id)

    if (isSelected) {
      this.removeOptional(optional.id)
      optional.quantity = 0
      return
    }

    this.cart.optionals.push(optional)
    optional.quantity = 1
  },

  updateOptionalSelection(optional) {
    const isSelected = this.getSelectedOptional(optional.id)
    if (! optional.quantity) {
      optional.quantity = 0
    }
    if (isSelected) {
      isSelected.quantity = optional.quantity
    }
    if (optional.quantity > 0 && !isSelected) {
      this.cart.optionals.push(optional)
      return
    }

    if (!optional.quantity && isSelected) {
      this.removeOptional(optional.id)
      return
    }
  },
}
